import { createFileRoute } from "@tanstack/react-router"
import { ResourcePageRequest } from "@/orval/gen/model"
import { ResourcesPage } from "./-components/ResourcesPage"

export const Route = createFileRoute("/app/resources/resources")({
  component: ResourcesPage,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t && t("Resources_Title"),
  }),
  validateSearch: (
    search: Omit<ResourcePageRequest, "pageParam" | "pageSize">
  ) => ({
    ...search,
    availableCount: search.availableCount ?? 1,
  }),
})
